export default __webpack_public_path__ + "static/media/paragraph.196d1b17.svg";